import React from "react";
import QrScanner from "react-qr-scanner";
interface QRScannerProps {
    closeScanner: () => void;
    onScan: (data: string | unknown) => void;
}

const QRScanner: React.FC<QRScannerProps> = ({ closeScanner, onScan }) => {
    const handleScan = (data: unknown) => {
        if (data) {
            const d = data as { text?: string };
            onScan(d.text || (data as string)); // Pass scanned data to parent
        }
    };

    const handleError = (err: unknown) => {
        console.error(err);
    };

    return (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-75">
            <div className=" flex items-center justify-center w-full h-full relative">
                {/* Close Button */}
                <button
                    onClick={closeScanner} // Ensure this calls the parent function
                    className="absolute top-4 right-4 text-white text-2xl font-bold"
                >
                    ✖
                </button>

                <div className="relative w-full max-w-sm h-96 bg-black rounded-lg overflow-hidden">
                    {/* QR Scanner */}
                    <div className="flex justify-center items-center h-full">
                        <QrScanner
                            delay={300}
                            onError={handleError}
                            onScan={handleScan}
                            style={{ width: "100%", height: "100%" }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default QRScanner;
